import React from 'react'
import { useQuery } from 'react-query';
import { fetchTradingViewAccess, fetchDashboardData } from '../../../api/dashboard';
import ScreenWidget from './components/ScreenWidget';
import TradingViewAccess from '../profile/TradingViewAccess';

// ICONS
import { IoMdHome } from "react-icons/io";
import { IoDocuments } from "react-icons/io5";
import { MdBarChart, MdDashboard } from "react-icons/md";
// widget
import Widget from "components/widget/Widget";
// alertpairs
import TaskCard from "views/admin/default/components/TaskCard";

// Renamed from "index" to "Dashboard" to follow React component naming convention
export default function Dashboard() {
  // Fetch TradingView access data with React Query
  const { 
    data: tvAccessData, 
    isLoading: isTvAccessLoading, 
    error: tvAccessError
  } = useQuery('tradingViewAccess', fetchTradingViewAccess, {
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnWindowFocus: false,
    retry: 1
  });

  // Fetch dashboard data to get subscription information
  const {
    data: dashboardData,
    isLoading: isDashboardLoading
  } = useQuery('dashboardData', fetchDashboardData, {
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnWindowFocus: false,
    retry: 1
  });

  // Get plan name from subscription data
  const getPlanName = () => {
    const subscription = dashboardData?.data?.subscription;
    
    if (!subscription || subscription.status !== 'active') {
      return "No Active Plan";
    }
    
    const planId = subscription.planId || "";
    
    if (planId.includes("Monthly")) return "Monthly Plan";
    if (planId.includes("Quarterly")) return "Quarterly Plan";
    if (planId.includes("Annually") || planId.includes("Annual")) return "Annual Plan";
    
    return planId || "Unknown Plan";
  };

  return (
    <>
      {/* Card widget */}

      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-2 2xl:grid-cols-2 3xl:grid-cols-2">
        {/* Removed widget components as they were already commented out */}
      </div>
      <div className="min-h-screen bg-cover bg-center dark:bg-navy-900 h-full mt-5">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-4 px-2 mb-4">
          <div className="flex flex-col items-start justify-center rounded-2xl bg-white bg-clip-border px-3 py-4 shadow-3xl shadow-shadow-500 dark:bg-navy-700 dark:shadow-none w-full sm:w-4/6 lg:w-full">
            <ScreenWidget />
          </div>
          <div className="flex flex-col justify-center rounded-2xl drop-shadow-2xl w-full sm:w-4/6 lg:w-full bg-white pl-3 pb-4 dark:!bg-navy-800">
            <h5 className="text-center text-xl font-bold leading-9 text-navy-700 dark:text-white">Current Plan</h5>
            <div className='prices text-blue-500 dark:text-white text-2xl md:text-xl lg:text-3xl bg-black font-bold flex items-center justify-center p-2'>
              {isDashboardLoading ? (
                <span className="opacity-70">Loading...</span>
              ) : (
                getPlanName()
              )}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-4 px-2">
          <TaskCard />

          <div className="flex flex-col rounded-2xl bg-white bg-clip-border px-3 py-4 shadow-3xl shadow-shadow-500 dark:bg-navy-700 dark:shadow-none w-full sm:w-4/6 lg:w-full">
            {/* Replaced Economic Calendar with TradingView Access component */}
            <h5 className="text-center text-xl font-bold leading-9 text-navy-700 dark:text-white mb-4">TradingView Access</h5>
            <TradingViewAccess 
              accessData={tvAccessData?.data} 
              isLoading={isTvAccessLoading} 
              error={tvAccessError} 
            />
          </div>
        </div>
      </div>
    </>
  );
}

